// src/utils/politicaMeta.js — o aviso de tema proibido enquanto a pessoa digita.
//
// Out/26 (blindagem contra banimento). A regra mora no servidor
// (services/politica_meta) e chega por `GET /templates/politica`: os temas,
// os padrões e os que o ADMIN liberou para a empresa. Aqui só se repete a
// normalização — sem acento, minúsculo, `_` vira espaço, espaços juntos —
// e a frase do bloqueio, pra a tela dizer ANTES o que o servidor recusaria
// com 422. Mudou a normalização ou a frase lá, muda aqui.

const ACENTOS = /[\u0300-\u036f]/g;

// O texto normalizado e, pra cada caractere dele, onde ele começa e termina
// no original — pra citar o trecho como a pessoa escreveu ("crédito"), não
// como o padrão leu ("credito"). Mesma regra de `_normalizar_com_mapa`.
function normalizarComMapa(texto) {
  const original = String(texto || '');
  const saida = [];
  const ini = [];
  const fim = [];
  let espaco = false;
  for (let i = 0; i < original.length;) {
    const ch = String.fromCodePoint(original.codePointAt(i));
    const proximo = i + ch.length;
    const limpo = ch.normalize('NFKD').replace(ACENTOS, '').toLowerCase().replace(/_/g, ' ');
    for (const x of limpo) {
      if (/\s/.test(x)) { espaco = saida.length > 0; continue; }
      if (espaco) { saida.push(' '); ini.push(i); fim.push(proximo); espaco = false; }
      // Uma entrada por unidade UTF-16: é assim que `match().index` conta
      // (emoji ocupa duas).
      for (let k = 0; k < x.length; k += 1) { saida.push(x[k]); ini.push(i); fim.push(proximo); }
    }
    i = proximo;
  }
  return { texto: saida.join(''), ini, fim };
}

export function normalizar(texto) {
  return normalizarComMapa(texto).texto;
}

// Compila uma vez por resposta do servidor. Padrão que o navegador não
// entender fica de fora — o servidor continua barrando.
export function compilarPolitica(politica) {
  const liberados = new Set(politica?.liberados || []);
  return (politica?.temas || [])
    .filter((t) => !liberados.has(t.chave))
    .map((t) => ({
      ...t,
      regexes: (t.padroes || []).map((p) => {
        try { return new RegExp(p); } catch { return null; }
      }).filter(Boolean),
    }));
}

/** O primeiro tema proibido nos textos, ou null — mesma ordem do servidor. */
export function verificarTema(compilada, textos) {
  const original = (textos || []).filter(Boolean).join(' \n ');
  const { texto: junto, ini, fim } = normalizarComMapa(original);
  if (!junto) return null;
  for (const tema of compilada || []) {
    for (const re of tema.regexes) {
      const achado = junto.match(re);
      if (!achado) continue;
      let a = achado.index;
      let b = a + achado[0].length;
      while (a < b && junto[a] === ' ') a += 1;
      while (b > a && junto[b - 1] === ' ') b -= 1;
      const trecho = b > a ? original.slice(ini[a], fim[b - 1]) : achado[0];
      return {
        chave: tema.chave, nome: tema.nome, regra: tema.regra,
        trecho: trecho.split(/\s+/).filter(Boolean).join(' '),
      };
    }
  }
  return null;
}

/** A mesma frase de `politica_meta.mensagem`. */
export function mensagemTema(achado) {
  return (
    `A Cetto não envia este template: ele fala de ${achado.nome} (“${achado.trecho}”). `
    + `${achado.regra} A Meta bane número e conta por isso, normalmente em poucas horas. `
    + 'Se a sua empresa é autorizada a oferecer isso e os contatos pediram para receber, '
    + 'fale com o suporte da Cetto para avaliar a liberação.'
  );
}
